<template>
  <div class="forum">
    <div class="bread">
      <router-link
        :to="{ name: fromRoute.name, query: { tab: fromRoute.tab } }"
      >{{ fromRoute.label }}</router-link>
      <span class="slash">/</span>
      <span class="current">小组主页</span>
    </div>
    <div class="group-info">
      <div class="info">
        <div class="img-wrap">
          <ScaleImage class="img" :src="groupInfo.image" :width="90" :height="90" />
        </div>
        <div class="content">
          <div class="name">
            <span>{{ groupInfo.name }}</span>
          </div>
          <p class="number">
            <span>话题：{{ groupInfo.post_num }}</span>
            <span class="user">成员：{{ groupInfo.user_num }}</span>
          </p>
          <button
            class="add"
            v-if="groupInfo.is_user_add == 2"
            @click="addGroup()"
            type="button"
          >加入小组</button>
          <button class="out" v-else @click="outGroup()" type="button">退出小组</button>
        </div>
      </div>
      <div class="broadcast">
        <p class="title">版块介绍：</p>
        <p class="message">{{ groupInfo.introduction }}</p>
      </div>
    </div>
    <div class="forum-box">
      <div class="left">
        <div class="bbs-box">
          <el-tabs v-model="activeName" @tab-click="hotNewChange()">
            <el-tab-pane label="热门话题" name="1">
              <ul class="forum-list">
                <CommunityItem
                  v-for="item in topicList"
                  :key="item.id"
                  :item="item"
                  @complaint="onComplaint(item)"
                  @delete="getTopicList"
                ></CommunityItem>
              </ul>
            </el-tab-pane>
            <el-tab-pane label="最新话题" name="2">
              <ul class="forum-list">
                <CommunityItem
                  v-for="item in topicList"
                  :key="item.id"
                  :item="item"
                  @complaint="onComplaint(item)"
                  @delete="getTopicList"
                ></CommunityItem>
              </ul>
            </el-tab-pane>
          </el-tabs>
          <Empty v-if="topicList.length == 0" class="empty" title="暂无帖子！" />
          <el-pagination
            v-if="topicList.length > 0"
            background
            layout="prev, pager, next"
            @current-change="handle_current_change"
            :page-size="limit"
            :current-page="page"
            :total="totalPage"
          ></el-pagination>
        </div>
      </div>
      <div class="right">
        <button @click="targetPost" type="button" class="post">
          <span>发帖</span>
        </button>
        <div class="mine m-notice">
          <p class="title">
            <span>版块公告</span>
          </p>
          <div class="notice">{{ groupInfo.announcement }}</div>
        </div>
        <div class="mine m-user">
          <p class="title">小组成员</p>
          <el-row class="team" :gutter="30">
            <el-col :span="6" v-for="item in groupUser" :key="item.id">
              <div class="grid-content">
                <div class="img">
                  <img :src="item.avatar" />
                </div>
                <p class="eps">{{ item.nickname }}</p>
              </div>
            </el-col>
          </el-row>
        </div>
      </div>
    </div>
    <Complaint ref="complaint"></Complaint>
  </div>
</template>

<script>
import CommunityItem from "../../components/CommunityItem";
import Complaint from "../../components/Complaint.vue";
export default {
  name: "Course",
  components: { CommunityItem, Complaint },
  data() {
    return {
      fromRoute: {
        name: this.$route.query.routeName || "Community",
        label: this.$route.query.routeLabel || "社区",
        tab: this.$route.query.tab || null
      },
      activeName: "1", //话题类型
      groupInfo: {}, //小组信息
      groupUser: [], //小组成员
      topicList: [], //话题列表
      totalPage: 0, //话题数量
      page: 1, //话题分页
      limit: 10 //话题分页限制
    };
  },
  async created() {
    await this.getGroupInfo();
    await this.getGroupUser();
    await this.getTopicList();
  },
  mounted: function() {},
  methods: {
    //获取小组信息
    async getGroupInfo() {
      const that = this;
      let data = await that.$http.get(
        "/api/app/community/group/detail/" + this.$route.params.id
      );
      that.groupInfo = data;
    },

    //获取小组成员
    async getGroupUser() {
      const that = this;
      let data = await that.$http.get(
        "/api/app/community/group/groupUsers/" + this.$route.params.id
      );
      that.groupUser = data.list;
    },

    // 热门最新话题切换
    async hotNewChange() {
      this.page = 1;
      this.getTopicList();
    },

    // 获取话题列表
    async getTopicList() {
      const that = this;
      let data = await that.$http.get("/api/app/community/post?", {
        group_id: that.$route.params.id,
        order: "desc",
        order_by: that.activeName == 1 ? "click_num" : "",
        page: that.page,
        limit: that.limit
      });
      that.topicList = data.list;
      that.totalPage = data.total;
    },

    // 分页加载数据
    handle_current_change(val) {
      this.page = val;
      this.getTopicList();
    },

    // 跳转发帖
    targetPost() {
      const that = this;
      if (that.$store.state.token) {
        if (that.groupInfo.is_user_add == 2) {
          that.$message({
            type: "success",
            message: "请先加入小组"
          });
          return;
        }
        that.$router.push({
          name: "CommunityPost"
        });
      } else {
        that.$router.push({
          name: "Login"
        });
      }
    },

    // 加入小组
    async addGroup() {
      const that = this;
      if (that.$store.state.token) {
        await that.$http.get(
          "/api/app/community/group/addGroup/" + this.$route.params.id
        );
        that.getGroupInfo();
        that.getGroupUser();
        that.$message({
          type: "success",
          message: "加入成功！"
        });
      } else {
        that.$router.push({
          name: "Login"
        });
      }
    },

    // 取消加入
    async outGroup() {
      const that = this;
      if (that.$store.state.token) {
        await this.$confirm(
          "退出后该小组将从我的小组中移除，确定退出该小组吗？",
          "提示",
          {
            type: "warning"
          }
        );
        await that.$http.get(
          "/api/app/community/group/outGroup/" + this.$route.params.id
        );
        that.getGroupInfo();
        that.getGroupUser();
        that.$message({
          type: "success",
          message: "退出成功！"
        });
      } else {
        that.$router.push({
          name: "Login"
        });
      }
    },
    onComplaint(item) {
      this.$refs.complaint.show(4, item.id);
    }
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
.forum {
  padding-bottom: 60px;
  background-color: #f5f7f9;
  overflow: hidden;
  .bread {
    width: 1200px;
    margin-right: auto;
    margin-left: auto;
    box-sizing: border-box;
  }
  .group-info {
    width: 1200px;
    margin: 0 auto 30px;
    padding: 40px;
    background: url("~@/assets/images/forum_group_show_bg.png") center no-repeat;
    background-size: cover;
    border-radius: 5px;
    box-sizing: border-box;
    box-shadow: 0 16px 20px 0 rgba(0, 0, 0, 0.07);
    .info {
      overflow: hidden;
      .img-wrap {
        float: left;
        width: 90px;
        height: 90px;
        border-radius: 10px;
        overflow: hidden;
        flex-shrink: 0;

        .img {
          border-radius: 10px;
        }
      }
      .content {
        margin-left: 110px;
        width: auto;
        .name {
          font-size: 19px;
          color: #20242a;
          line-height: 26px;
        }
        .number {
          margin-top: 10px;
          font-size: 14px;
          color: #8c8c8c;
          line-height: 14px;
          .user {
            position: relative;
            display: inline-block;
            margin-left: 20px;
            &::after {
              content: "";
              width: 1px;
              height: 14px;
              background-color: #fff;
              position: absolute;
              left: -10px;
              top: 50%;
              margin-top: -7px;
            }
          }
        }
        button.add {
          margin-top: 15px;
          width: 80px;
          height: 23px;
          line-height: 21px;
          background: $primary-color-1;
          border: none;
          border-radius: 12px;
          text-align: center;
          font-size: 13px;
          color: $primary-color;
          cursor: pointer;
          outline: none;
          &:hover {
            background: $primary-color;
            color: #fff;
          }
        }
        button.out {
          margin-top: 15px;
          width: 80px;
          height: 23px;
          line-height: 21px;
          background: #f4f4f4;
          border: none;
          border-radius: 12px;
          text-align: center;
          font-size: 13px;
          color: #8c8c8c;
          cursor: pointer;
          outline: none;
          &:hover {
            color: #000000;
          }
        }
      }
    }
    .broadcast {
      margin-top: 30px;
      .title {
        font-size: 14px;
        color: #20242a;
      }
      .message {
        margin-top: 5px;
        line-height: 22px;
        overflow: hidden;
        font-size: 14px;
        color: #8c8c8c;
      }
    }
  }
  .forum-box {
    overflow: hidden;
    width: 1200px;
    margin: 30px auto 0;
    & /deep/ .el-tabs__header {
      margin: 0;
      background-color: #f8f8f8;
      .el-tabs__nav-wrap::after {
        display: none;
      }
      .el-tabs__item {
        padding: 0;
        height: 55px;
        width: 165px;
        line-height: 55px;
        text-align: center;
        font-family: PingFangSC-Medium;
        font-size: 16px;
        color: #b7b7b7;
      }
      .is-active {
        position: relative;
        background-color: #fff;
        color: $primary-color;
        &::after {
          position: absolute;
          left: 50%;
          bottom: 0;
          height: 3px;
          width: 28px;
          margin-left: -14px;
          background-color: $primary-color;
          border-radius: 2px;
          content: "";
        }
      }
      .el-tabs__active-bar {
        display: none;
        height: 3px;
        background-color: $primary-color;
      }
    }
    .left {
      float: left;
      width: 830px;
      border-radius: 5px;
      overflow: hidden;
      .bbs-box {
        background-color: #fff;
        overflow: hidden;
        .forum-list {
          padding: 0 25px;
        }
      }
    }
    .right {
      margin-left: 860px;
      width: auto;
      .post {
        display: block;
        width: 100%;
        padding: 0 0 0 130px;
        height: 60px;
        line-height: 60px;
        border: none;
        box-shadow: 0px 6px 20px 0px $primary-color-04,
          0px 13px 33px 0px rgba(0, 0, 0, 0.04);
        border-radius: 32px;
        background: url("~@/assets/images/icon_fourm_post.png") 180px center
          no-repeat #fff;
        background-size: 18px 18px;
        text-align: left;
        font-size: 20px;
        color: #595959;
        outline: none;
        cursor: pointer;
        &:hover {
          background: url("~@/assets/images/icon_fourm_post_active.png") 180px
            center no-repeat $primary-color;
          background-size: 18px 18px;
          color: #fff;
        }
      }
      .mine {
        margin-top: 20px;
        padding: 0 20px;
        background-color: #fff;
        border-radius: 5px;
        .title {
          position: relative;
          padding: 0 20px;
          height: 50px;
          border-bottom: 1px solid #edf1f2;
          font-size: 16px;
          font-family: PingFangSC-Medium;
          color: #5b6066;
          line-height: 50px;
          i {
            position: absolute;
            top: 20px;
            right: 0;
            display: block;
            width: 6px;
            height: 11px;
            background: url("~@/assets/images/icon_fourm_right_arrow.png")
              center no-repeat;
            background-size: 100% 100%;
          }
        }
        .no-login {
          display: block;
          height: 220px;
          background: url("~@/assets/images/fourm_no_login_bg.png") center
            no-repeat #fff;
          background-size: 200px 100px;
          line-height: 320px;
          text-align: center;
          font-size: 17px;
          color: #20242a;
        }
        .list {
          a {
            display: block;
            margin: 10px 0;
            line-height: 14px;
            font-size: 14px;
            color: #333;
          }
        }
      }
      .m-notice {
        overflow: hidden;
        .title {
          background: url("~@/assets/images/icon_fourm_title_notice.png") left
            center no-repeat;
          background-size: 16px 16px;
        }
        .notice {
          padding: 20px 0;
          min-height: 170px;
          font-size: 16px;
          color: #20242a;
          line-height: 30px;
          box-sizing: border-box;
        }
      }
      .m-user {
        padding: 0 20px 40px;
        overflow: hidden;
        .title {
          background: url("~@/assets/images/icon_fourm_title_user.png") left
            center no-repeat;
          background-size: 16px 16px;
        }
        .grid-content {
          margin: 20px 0 0;
          .img {
            width: 100%;
            height: 54px;
            img {
              display: block;
              width: 54px;
              height: 52px;
              border-radius: 50%;
            }
          }
          p {
            margin-top: 6px;
            text-align: center;
            font-size: 12px;
            color: #000000;
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: nowrap;
            line-height: 12px;
          }
        }
      }
    }
  }
}
</style>
